<template>
  <div class="mt-4">
    <cabecalho
      title="ACADEMICO_MATRICULAS.CONTRATOS"
      description="ACADEMICO_MATRICULAS.MATRICULA_CONTRATO_EXPLICACAO"
      title_type="body"
    />
    <b-table
      head-variant="light"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      :items="contratos"
      :fields="campos"
      :tbody-tr-class="retornarClasseLinhaAno"
      show-empty
      striped
      hover
    >
      <template #cell(acoes)="item">
        <b-dropdown
          variant="outline-default"
          v-if="
            verificarPermissao('Contrato', 'Visualizar') &&
            item.item.ano == false
          "
        >
          <b-dropdown-item
            @click="baixarContrato(item.item)"
            v-if="!item.item.extraClasse && podeVisualizar"
          >
            {{ $t('ACADEMICO.DOWNLOAD_CONTRATO') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import pdf from '@/common/utils/pdf';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import ContratosService from '@/common/services/contratos/contratos.service';

// Components:
import { Cabecalho } from '@/components/headers/index';

export default {
  name: 'Contratos',
  mixins: [Permissoes],
  components: {
    Cabecalho,
  },
  props: {
    matriculaId: { type: String, default: null },
  },
  data() {
    return {
      campos: [
        {
          key: 'codigo',
          label: this.$t('GERAL.CODIGO'),
        },
        {
          key: 'status',
          label: this.$t('GERAL.STATUS'),
        },
        {
          key: 'idioma',
          label: this.$t('GERAL.IDIOMA'),
        },
        {
          key: 'tipo',
          label: 'Tipo contrato',
        },
        {
          key: 'descricao',
          label: 'Descrição',
        },
        {
          key: 'turma',
          label: 'Turma',
        },
        {
          key: 'dataCriacao',
          label: 'Data de criação',
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
      contratos: [],
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    listar() {
      this.$store.dispatch(START_LOADING);
      ContratosService.buscarPorMatriculaId(this.matriculaId)
        .then(({ data }) => {
          this.contratos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    baixarContrato({ id }) {
      this.$store.dispatch(START_LOADING);

      ContratosService.baixarPDF(id)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);

            let blob = new Blob([bytes], { type: 'application/pdf' });

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    retornarClasseLinhaAno(item, type) {
      if (!item || type !== 'row') return;
      if (item.ano === true) return 'line-table-custom';
    },
  },
};
</script>
